import { createAsyncThunk } from '@reduxjs/toolkit';
import { Middleware } from 'redux';
import { ApplicationState } from '../store';
import { AppDispatch } from '../store';

import { fieldsActions, predictionsActions, socketsActions } from '../actions/actions';
import { ISocketMessage } from '../../Types/SocketMessages';
import { IField } from '../../Types/Field';
import { IPrediction_v0 } from '../../Types/Predictions';

import { REACT_APP_SOCKETS } from '../../AppConfig';

let socket: WebSocket | null = null;

const processMessage = (data: string): any => {
  let msg: ISocketMessage = JSON.parse(data);
  console.log("msg: ", msg);
  // current shenanigans for testing with websocket dumb server
  if (msg.payload != null) {
    console.log("message body: ", msg.payload);
    msg = JSON.parse(JSON.parse(data).body);
  }

  console.log('msg: ', msg);
  console.log('msg.type: ', msg.type, '  msg.action: ', msg.action)
  switch (msg.type) {
    case 'AUTH':
      console.log('AUTH msg: ', msg);
      // we don't care client side
      break;
    case 'FIELD':
      console.log('FIELD');
      switch (msg.action) {
        case 'ADD':
          console.log('ADD');
          return fieldsActions.addField(JSON.parse(msg.payload) as IField);
        case 'DELETE':
          return fieldsActions.deleteField(JSON.parse(msg.payload) as IField);
        case 'UPDATE':
          return fieldsActions.updateField(JSON.parse(msg.payload) as IField);
        default:
          break;
      }
      break;
    case 'PREDICTION':
      console.log('PREDICTION');
      switch (msg.action) {
        case 'ADD':
        case 'UPDATE':
          console.log('ADD');
          return predictionsActions.addPrediction(JSON.parse(msg.payload) as IPrediction_v0);
        case 'DELETE':
          return predictionsActions.removePrediction(JSON.parse(msg.payload) as IPrediction_v0);
        default:
          break;
      }
      break;
    default:
      break;
  }
}

// Initial connection to socket that also sets up event listeners for socket callbacks.
export const connectSockets = createAsyncThunk<
  void,
  null,
  {
    // Optional fields for defining thunkApi field types
    dispatch: AppDispatch
    state: ApplicationState
    extra: {
      jwt: string
    }
  }>(
    'sockets/connectSockets',
    async (placeholder, thunkApi) => {
      console.log('sockets/connectSockets');
      console.log('socket: ', socket);
      // thunkApi.dispatch(socketsActions.connect);
      if (socket !== null) {
        socket.close();
      }

      socket = new WebSocket(REACT_APP_SOCKETS);
      socket.addEventListener('open', (event) => {
        console.log('websocket open: ', event);
        thunkApi.dispatch(socketsActions.connectionState(event.type));
      });
      socket.addEventListener('message', data => {
        console.log('websocket message: ', data);
        processMessage(data.data);
        thunkApi.dispatch(socketsActions.connectionState(data.type));
      });
      socket.addEventListener('close', (event) => {
        console.log('websocket close: ', event);
        thunkApi.dispatch(socketsActions.connectionState(event.type));
      });
      socket.addEventListener('error', (event) => {
        console.log('websocket error: ', event);
        thunkApi.dispatch(socketsActions.connectionState(event.type));
      });
      // thunkApi.dispatch(predictionsActions.loadingFinished);
      return;
    }
  );

export const closeSocket = createAsyncThunk<
  void,
  null,
  {
    // Optional fields for defining thunkApi field types
    dispatch: AppDispatch
    state: ApplicationState
    extra: {
      jwt: string
    }
    requestId: string
    signal: AbortSignal
  }>(
    'sockets/closeSocket',
    async (placeholder, thunkApi) => {
    console.log('sockets/closeSocket');
    console.log('socket: ', socket);

    if (socket !== null) {
      socket.close();
      socket = null;
    }

    return;
  }
);

// Our custom authentication mechanism. Basically send the jwt to the socket.
// Server side the connection isn't logged as being 'active' to receive any
// messages until after this message has been sent and validated. This just
// is a safety step to ensure the connected endpoint has previously authenticated
// against the OIDC. Backend uses the same authorization routine as for the 
// standard API calls.
export const authenticateSocket = createAsyncThunk<
  void,
  null,
  {
    // Optional fields for defining thunkApi field types
    dispatch: AppDispatch
    state: ApplicationState
    extra: {
      jwt: string
    }
    requestId: string
    signal: AbortSignal
  }>(
    'sockets/authenticateSocket',
    async (placeholder, thunkApi) => {
      console.log('sockets/authenticateSocket');
      const msg: ISocketMessage = {
        type: 'AUTH',
        action: 'ADD',
        payload: `Bearer ${thunkApi.getState().security.token}`
      };

      socket?.send(JSON.stringify(msg));
    }
  );

// Sending a message from the client. Nothing else special here
export const sendMessage = createAsyncThunk<
  void,
  ISocketMessage,
  {
    // Optional fields for defining thunkApi field types
    dispatch: AppDispatch
    state: ApplicationState
    extra: {
      jwt: string
    }
    requestId: string
    signal: AbortSignal
  }>(
    'sockets/sendMessage',
    async (msg, thunkApi) => {
      console.log('sockets/sendMessage');
      console.log('msg: ', msg);

      socket?.send(JSON.stringify(msg));
    }
  );

const sockets: Middleware = store => next => action => {
  let result = next(action)
  if (action.type === socketsActions.connect.type) {
    connectSockets(store.getState());
  }

  return result
}

export default sockets;